module.exports = __webpack_public_path__ + "img/email.ce2d3a28.svg";